const defaulDaysFilter = 90

const summaryDatatable = {
  total_invoices: 0,
  total_occurrences: 0,
  total_amount: 0,
  total_available_amount: 0,
  total_payment_amount: 0,
  total_anticipated_amount: 0,
  total_invoices_status_quitada: 0,
  total_invoices_status_aberto: 0,
  total_invoices_status_antecipado: 0,
  days_filter: defaulDaysFilter,
  cnpjs: [],
  cnpjs_payers: [],
  invoice_number: '',
  scheduled_date_init: '',
  scheduled_date_end: '',
  payment_date_init: '',
  payment_date_end: '',
  status: '',
  local_type: '',
  paramsQuery: ''
}

export default {
  corretor: {
    avalaible: 0,
    pending: 0,
    total: 0,
    percents: {
      avalaible: 0,
      pending: 0
    }
  },
  dashboard: {},
  dashboardSummary: [
    {
      name: 'Indisponível',
      y: 0,
      color: '#00c5dc'
    },
    {
      name: 'Em resgate',
      y: 0,
      color: '#716aca'
    },
    {
      name: 'A resgatar',
      y: 0,
      color: '#ffb822'
    }
  ],
  summaryDatatable: { ...summaryDatatable }
}



// WEBPACK FOOTER //
// ./src/features/dashboard/store/state.js